<script lang="ts" setup>
// Properties
const props = defineProps({
    type: {
        type: String,
        default: "button",
    },
});

// Data
</script>

<template>
    <div
        class="flex items-center text-center before:mr-4 before:flex-1 before:border-b before:border-gray-400 after:ml-4 after:flex-1 after:border-b after:border-gray-400"
    >
        <slot></slot>
    </div>
</template>

<style scoped></style>
